import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  main: {
    marginLeft: 50,
    marginRight: 50,
  },
  text: {
    paddingTop: 20,
    fontSize: 15,
  },
  tableHeader: {
    paddingTop: 20,
    fontSize: 15,
    fontWeight: 450,
  },
  textTabSelected: {
    color: "#F78F2D",
    fontSize: 20,
  },
  textTabUnselected: {
    color: "#696969",
    fontSize: 20,
  },
  divider: {
    backgroundColor: "#828181",
  },
  expandedInput: {
    display: "flex",
    width: "100%",
    height: 30,
  },
  paper: {
    width: "100%",
    backgroundColor: "#ffffff",
    paddingTop: 40,
    paddingRight: 40,
    paddingBottom: 40,
  },
  padding: {
    paddingRight: 20,
    paddingLeft: 10,
    marginLeft: 20,
    marginRight: 20,
  },
  table: {
    maxWidth: 1400,
    marginBottom: 200,
    marginTop: 50,
  },
  textField: {
    display: "flex",
    width: "98%",
    // minWidth: 700,
    borderColor: "#00000026",
    height: "40px",
    borderRadius: "5px",
    fontFamily: "Fira Sans",
    fontSize: 14,
    color: "#000000cc",
    borderWidth: 1,
    padding: 5,
  },
  title: {
    fontWeight: 800,
    fontSize: 14,
  },
  icon: {
    color: "#f78f2d",
  },
  headerBorder: {
    borderBottom: "1px solid grey",
  },
  rowBorder: {
    borderBottom: "none",
  },
  table1: {
    maxWidth: 800,
  },
  mr: {
    marginRight: 20,
  },
  ml: {
    marginLeft: 20,
  },
}));

export const defaultProps = {
  bgcolor: "background.paper",
  m: 1,
  borderColor: "#D3D3D3",
};
